import Logo from "@/components/Logo";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  const COLS = [
    {
      title: t("footer.shop"),
      links: [
        [t("footer.axe"), "/winkel?brand=axe"],
        [t("footer.allBrands"), "/winkel"],
      ],
    },
    {
      title: t("footer.service"),
      links: [
        [t("footer.contact"), "/contact"],
        [t("footer.faq"), "/faq"],
        [t("footer.shipping"), "/verzending"],
        [t("footer.returns"), "/retourneren"],
      ],
    },
  ];
  return (
  <footer className="border-t border-gold/10 bg-ink/40 px-6 sm:px-12 lg:px-20 pt-20 pb-10">
    <div className="grid gap-12 lg:grid-cols-[1.2fr_2fr]">
      <div>
        <Logo />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-mist">
          {t("footer.about")}
        </p>
        <p className="mt-6 font-mono text-[10px] tracking-[0.25em] uppercase text-smoke">
          {t("footer.vat")}
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-8">
        {COLS.map((col) => (
          <div key={col.title}>
            <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-smoke mb-4 block">{col.title}</span>
            <div className="flex flex-col gap-3">
              {col.links.map(([label, path]) => (
                <a
                  key={label}
                  data-testid={`footer-link-${path}`}
                  href={path}
                  className="font-mono text-xs tracking-[0.15em] uppercase text-mist hover:text-gold transition-colors duration-300"
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>

    <p className="mt-20 font-serif font-light uppercase text-4xl sm:text-6xl lg:text-8xl text-outline-gold leading-none select-none">
      DEO ATELIER
    </p>

    <div className="mt-10 flex flex-col sm:flex-row justify-between gap-4 border-t border-gold/10 pt-6">
      <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-smoke">
        © {new Date().getFullYear()} DEO ATELIER — House of Deo
      </p>
      <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-smoke">
        {t("footer.tagline")}
      </p>
    </div>
  </footer>
  );
};

export default Footer;
